setTimeout(() => {
    let sliders = document.querySelectorAll('.app-slider-wrapper .fs-entry-container');
    if (sliders.length == 0) {
        document.querySelector('.app__title').classList.add('app__title--hidden');
    }
}, "1500");